<template>
  <b-dropdown
      position="is-bottom-left"
      append-to-body
      aria-role="menu"
      >
    <a
        class="navbar-item"
        slot="trigger"
        role="button" >
      <span class="is-hidden-desktop navbar-item-label">Need Help? </span>
      <b-icon icon="help-circle-outline"></b-icon>

    </a>
    <b-dropdown-item
        aria-role="menu-item"
        :focusable="false"
        custom
    >
      <div>
        <b-message>
          <article class="media">
            <figure class="media-left">
              <b-icon
                  icon="email-edit-outline"
                  size="is-medium"
                  class="has-text-grey-light"
              >
              </b-icon>
            </figure>
            <div class="media-content">
              <div class="content">
                <p class="is-size-6"><strong>Need support with your TripCircuit online booking?</strong>
                  <br>
                  <span>Email Gant's Online Team:
                    <a class="gant-text" href="mailto:clientservices@ganttravel.com">
                      clientservices@ganttravel.com
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </article>
        </b-message>
        <b-message>
          <article class="media">
            <figure class="media-left">
              <b-icon
                  icon="face-agent"
                  size="is-medium"
                  class="has-text-grey-light"
              >
              </b-icon>
            </figure>
            <div class="media-content">
              <div class="content">
                <p class="is-size-6"><strong>Booking Same-Day Travel or need After-Hours assistance?</strong>
                  <br>
                  <span>
                      Contact Gant Travel directly for agent assistance at <span style="white-space: nowrap;" class="gant-text">(877) 924-0303</span>
                    </span>
                </p>
              </div>
            </div>
          </article>
        </b-message>
        <b-message>
          <article class="media">
            <figure class="media-left">
              <b-icon
                  icon="passport"
                  size="is-medium"
                  class="has-text-grey-light"
              >
              </b-icon>
            </figure>
            <div class="media-content">
              <div class="content">
                <p class="is-size-6"><strong>Traveling Internationally?</strong>
                  <br>
                  <span>
                      <a  class="gant-text" href="https://cibtvisas.com/gant-travel?login=ganttravel" target="_blank">
                        View International Visa Requirements
                      </a>
                    </span>
                </p>
              </div>
            </div>
          </article>
        </b-message>
        <b-message>
          <article class="media">
            <figure class="media-left">
              <b-icon
                  icon="account-group-outline"
                  size="is-medium"
                  class="has-text-grey-light"
              >
              </b-icon>
            </figure>
            <div class="media-content">
              <div class="content">
                <p class="is-size-6"><strong>Need help with a Current Meeting?</strong>
                  <br>
                  <span>
                    To request help / support for your meeting, email us at <a href="mailto:meetings@ganttravel.com" class="gant-text">meetings@ganttravel.com</a>
                    </span>
                </p>
              </div>
            </div>
          </article>
        </b-message>
        <b-message>
          <article class="media">
            <figure class="media-left">
              <b-icon
                  icon="account-group-outline"
                  size="is-medium"
                  class="has-text-grey-light"
              >
              </b-icon>
            </figure>
            <div class="media-content">
              <div class="content">
                <p class="is-size-6"><strong>Interested in seeing our Meeting Tool?</strong>
                  <br>
                  <span>
                    To request a demo, email us at <a href="mailto:sales@ganttravel.com" class="gant-text">sales@ganttravel.com</a>
                    </span>
                </p>
              </div>
            </div>
          </article>
        </b-message>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "UserNeedHelpDropdown"
}
</script>

<style scoped>

</style>